import { render, staticRenderFns } from "./GynecologyCard.vue?vue&type=template&id=968f5486&scoped=true"
import script from "./GynecologyCard.vue?vue&type=script&lang=js"
export * from "./GynecologyCard.vue?vue&type=script&lang=js"
import style0 from "./GynecologyCard.vue?vue&type=style&index=0&id=968f5486&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "968f5486",
  null
  
)

export default component.exports